import mod from "-!../../../../node_modules/babel-loader/lib/index.js?cacheDirectory!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Link.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js?cacheDirectory!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Link.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/Sidebar/Link.vue?vue&type=script&lang=js&
// module id = null
// module chunks = 